import React from "react";
import SvgIcon from 'react-icons-kit';
import { Button } from 'react-bootstrap';

const IconButton = (props)=>{
    return(
        <Button 
            className={"btn "+props.class} 
            disabled={props.disabled} 
            title={props.title} 
            style={props.styles} 
            onClick={(e) => props.action(e, props.variables)}
        >
            <SvgIcon icon={props.icon} style={{paddingTop:"3px"}}/>
        </Button>
    )
}

export default IconButton;

IconButton.defaultProps = {
    variables:"",
    disabled:false,
    styles:{},
    class:'btn-info btn-xs'
}

